"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _axios = _interopRequireDefault(require("axios"));
var _ShopContext = _interopRequireDefault(require("../../context/ShopContext"));
var _useIsLoggedIn = _interopRequireDefault(require("../../hooks/useIsLoggedIn"));
var _CartRoot = _interopRequireDefault(require("../../Cart/CartRoot"));
var _MessageRoot = _interopRequireDefault(require("../MessageRoot"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Shop = _ref => {
  let {
    children,
    lang = "de"
  } = _ref;
  const [shopData, setShopData] = (0, _react.useState)({});
  const isLoggedIn = (0, _useIsLoggedIn.default)();
  (0, _react.useEffect)(() => {
    const fetchShopData = async () => {
      const {
        REACT_APP_PATH
      } = process.env;
      const profileUrl = "".concat(REACT_APP_PATH, "/Micado.Shop.Web/Micado.Shop.Web.IO.Api.ShopApi/Details.api?lang=").concat(lang);
      const response = await _axios.default.get(profileUrl, null);
      setShopData(response.data);
    };
    fetchShopData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return /*#__PURE__*/_react.default.createElement(_ShopContext.default.Provider, {
    value: {
      shopData,
      setShopData
    }
  }, /*#__PURE__*/_react.default.createElement(_MessageRoot.default, null, /*#__PURE__*/_react.default.createElement(_CartRoot.default, {
    isLoggedIn: !!isLoggedIn
  }, children)));
};
var _default = exports.default = Shop;